export class BillingCloseSearchItemExport { 
    public Protocolo: string;
    public  Estado: string;
    public Fecha: Date;
    public Entidad: string;
    public Plan: string;
}